import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-01/lesson-21/task-04";

const task: Slide = {
  titleHtml: `Which modes of the 2D cavity shown below are excited<br>when the source is located at the following place?`,
  description: "Select the correct points.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 1,
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task04.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
